import React from 'react';
import Icon from '../../../components/AppIcon';

const ConnectionMethodsInfo = () => {
  const methods = [
    {
      icon: 'UserPlus',
      title: 'Direct Addition',
      description: 'Add dependent users directly by entering their information. Best for managing profiles of family members or those in your care.',
      color: 'primary'
    },
    {
      icon: 'Shield',
      title: 'Privacy & Permissions',
      description: 'All dependent data is securely stored and only accessible to you as the caregiver. You can view symptom history and create entries on their behalf.',
      color: 'success'
    },
    {
      icon: 'AlertCircle',
      title: 'Access Controls',
      description: 'Dependent users can be managed, edited, or removed at any time. Changes take effect immediately and maintain full data privacy.',
      color: 'warning'
    }
  ];

  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning'
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        How It Works
      </h3>
      <div className="space-y-4">
        {methods?.map((method, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${colorClasses?.[method?.color]}`}>
              <Icon name={method?.icon} size={20} strokeWidth={2} />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {method?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {method?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectionMethodsInfo;